import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import {
    setEnableClosedSidebar,
    setEnableMobileMenu,
} from '../../reducers/ThemeOptions';
// import MetisMenu from 'react-metismenu';
// import RouterLink from 'react-metismenu-router-link';


// import { MainNav, ComponentsNav, FormsNav, WidgetsNav, ChartsNav } from './NavItems';

class Nav extends Component {
    permissions = this.props.permissions || [];
    state = {};

    toggleEnableClosedSidebar = () => {
        let { setEnableClosedSidebar, setEnableMobileMenu } = this.props;
        setEnableClosedSidebar(true);
        setEnableMobileMenu(false);
    }
    render() {
        return (
            <Fragment>
                <h5 className="app-sidebar__heading">Menu</h5>
                <div className="metismenu vertical-nav-menu" onClick={() => this.toggleEnableClosedSidebar()}>
                    <ul className="metismenu-container">
                        <li className="metismenu-item">
                            <Link className="metismenu-link" to="/main/blogs/view">
                                <i className="metismenu-icon pe-7s-diamond"></i>
                                Blogs
                            </Link>
                        </li>
                        {(this.permissions.includes('VIEW_USER') || this.permissions.includes('ADMIN')) &&
                            <li className="metismenu-item">
                                <Link className="metismenu-link" to="/main/users">
                                    <i className="metismenu-icon pe-7s-diamond"></i>
                                Users
                                </Link>
                            </li>
                        }
                        {(this.permissions.includes('MODIFY_ADS') || this.permissions.includes('ADMIN')) &&
                            <li className="metismenu-item">
                                <Link className="metismenu-link" to="/main/manage_statics">
                                    <i className="metismenu-icon pe-7s-diamond"></i>
                                Manage Ads
                                </Link>
                            </li>
                        }
                        {false && (this.permissions.includes('MODIFY_BLOG') || this.permissions.includes('ADMIN')) &&
                            <li className="metismenu-item">
                                <Link className="metismenu-link" to="/main/edit_blogs">
                                    <i className="metismenu-icon pe-7s-diamond"></i>
                                Edit Blogs
                                </Link>
                            </li>
                        }
                        {(this.permissions.includes('MANAGE_DEVICES') || this.permissions.includes('ADMIN')) &&
                            <li className="metismenu-item">
                                <Link className="metismenu-link" to="/main/devices">
                                    <i className="metismenu-icon pe-7s-diamond"></i>
                                    Devices
                                </Link>
                            </li>
                        }
                        {(this.permissions.includes('VIEW_ATTENDANCE') || this.permissions.includes('ADMIN')) &&
                            <li className="metismenu-item">
                                <Link className="metismenu-link" to="/main/viewAttendance">
                                    <i className="metismenu-icon pe-7s-diamond"></i>
                                    View Attendance
                                </Link>
                            </li>
                        }
                        {
                            <li className="metismenu-item">
                                <Link className="metismenu-link" to="/main/attendance">
                                    <i className="metismenu-icon pe-7s-diamond"></i>
                                    Attendance
                                </Link>
                            </li>
                        }
                    </ul>
                </div>
                {/* <h5 className="app-sidebar__heading">Menu</h5> */}
                {/* <MetisMenu content={MainNav} activeLinkFromLocation className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/> 
                <h5 className="app-sidebar__heading">UI Components</h5>
                <MetisMenu content={ComponentsNav} activeLinkFromLocation className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
                <h5 className="app-sidebar__heading">Widgets</h5>
                <MetisMenu content={WidgetsNav} activeLinkFromLocation className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
                <h5 className="app-sidebar__heading">Forms</h5>
                <MetisMenu content={FormsNav} activeLinkFromLocation className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
                <h5 className="app-sidebar__heading">Charts</h5>
                <MetisMenu content={ChartsNav} activeLinkFromLocation className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" /> */}

            </Fragment>
        );
    }

    isPathActive(path) {
        return this.props.location.pathname.startsWith(path);
    }
}

const mapStateToProps = state => ({
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
});

const mapDispatchToProps = dispatch => ({

    setEnableClosedSidebar: enable => dispatch(setEnableClosedSidebar(enable)),
    setEnableMobileMenu: enable => dispatch(setEnableMobileMenu(enable)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));